// extracted by mini-css-extract-plugin
module.exports = {"alert":"TruoraAlertNoStock-module__alert___8Xslf"};